export enum EngineType {
    BEV = 'BEV', //battery electric vehicle
    PHEV = 'PHEV', //plug-in hybrid electric vehicle
    ICE = 'ICE', //internal combustion engine
    CNG = 'CNG', //compressed natural gas
    HYDROGEN = 'Hydrogen', //hydrogen fuel cell
    UNKNOWN = 'Unknown' //unknown or not specified
}
